import {
  type IEventEmitterAction,
  type IEventEmitterActionKeys,
  type IEventEmitterCallback,
  type IEventEmitterCallbackEmit,
} from 'entities/EventEmitter/store/types'

export class EventEmitterStore<T extends IEventEmitterActionKeys> {
  private _events: Map<T, IEventEmitterCallbackEmit<T>[]> = new Map()

  subscribe<E extends T>(eventName: E, callback: IEventEmitterCallback<E>) {
    if (!this._events.has(eventName)) {
      this._events.set(eventName, [])
    }

    const callbacks = this._events.get(eventName)

    if (callbacks) {
      callbacks.push(callback as IEventEmitterCallbackEmit<T>)
      this._events.set(eventName, callbacks)
    }
  }

  unsubscribe<E extends T>(eventName: E, callback: IEventEmitterCallback<E>) {
    if (!this._events.has(eventName)) return

    let callbacks = this._events.get(eventName)

    if (callbacks) {
      callbacks = callbacks.filter((eventCallback) => callback !== eventCallback)
      this._events.set(eventName, callbacks)
    }
  }

  emit<E extends T>(eventName: E, args?: IEventEmitterAction[E]) {
    if (!this._events.has(eventName)) return

    const callbacks = this._events.get(eventName)

    if (callbacks) {
      callbacks.forEach((callback) => callback.call(null, args))
    }
  }
}

export const eventEmitterStore = new EventEmitterStore()
